<section
  class="relative flex min-h-[175px] w-full cursor-pointer flex-col justify-center overflow-hidden rounded-xl bg-[#e2eafc] p-6 text-sm text-black transition-all duration-200 ease-in-out hover:bg-[#EBF1FF] lg:min-h-[232px] lg:p-8"
  [class.clickable]="navigateOnClick"
>
  <div
    class="pointer-events-none absolute inset-0 z-0 grid place-items-center text-blue-300/30"
  >
    <mat-icon class="!h-[150px] !w-[150px] !text-[150px]">{{
      label === 'Orders'
        ? 'check'
        : label === 'Tickets'
          ? 'build'
          : 'directions_run'
    }}</mat-icon>
  </div>

  <div class="relative z-10 flex h-full w-full flex-col justify-center">
    <div class="mb-8 mt-0 flex w-full flex-col items-center justify-center">
      <div class="flex items-center">
        <div
          class="mr-2 pb-0 font-montserrat text-[4em] leading-none tracking-[-0.025em] lg:text-[6em]"
        >
          {{ number || 0 }}
        </div>
        <div class="flex flex-col flex-wrap justify-between">
          <div
            class="font-montserrat text-lg font-bold leading-none tracking-widest lg:text-xl"
          >
            {{ status }}
          </div>
          <div class="font-montserrat text-4xl leading-none lg:text-5xl">
            {{ label }}
          </div>
        </div>
      </div>

      <ng-content></ng-content>
    </div>

    <div
      class="absolute -bottom-4 left-1/2 max-h-fit w-full basis-full -translate-x-1/2 text-center text-base font-bold uppercase text-[#0D62FF]"
      [ngClass]="{ '-bottom-7': label === 'Tickets' }"
    >
      <a
        [routerLink]="hyperlink"
        [queryParams]="queryParams"
        class="border-b-2 border-b-[#0D62FF]"
      >
        {{ ctaText }}
      </a>
    </div>
  </div>

  @if (loading) {
    <div class="pointer-events-none absolute inset-0 z-0 grid place-items-end">
      <mat-progress-bar mode="indeterminate" />
    </div>
  }
</section>
